// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/distress-frequencies.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/distress-frequencies/distress-frequencies.js';

mount([g0]);
